import { Column } from '../../types/table';
import simpleSoilAttribute from './simpleSoilAttribute';

interface LayeredSoilAttributeProps {
  aggregationMethod?: string;
  allLayers: boolean;
  key: string;
  ratingCol?: Column;
  ruleId: string;
  units?: string;
}

const getShortFormData = (
  allLayers: boolean,
  AggregationMethod: string = 'Dominant Component',
) => ({
  AggregationMethod,
  HorizonAggregationMethod: allLayers ? 'All Layers' : 'Surface Layer',
});

const getName = (name: string, allLayers = true) =>
  `${name} (${allLayers ? 'All Layers' : 'Surface Layer'})`;

const layeredSoilAttribute = ({
  aggregationMethod,
  allLayers,
  key,
  ratingCol,
  ruleId,
  units,
}: LayeredSoilAttributeProps) =>
  simpleSoilAttribute({
    key: getName(key, allLayers),
    ratingCol,
    ruleId,
    shortFormData: getShortFormData(allLayers, aggregationMethod),
    units,
  });

export default layeredSoilAttribute;
